import type { FC, ReactNode } from 'react';
import styles from './Tag.module.css';

export interface TagProps {
  children: ReactNode;
  variant?: 'default' | 'accent' | 'outline';
}

export const Tag: FC<TagProps> = ({ children, variant = 'default' }) => (
  <span className={styles.tag} data-variant={variant}>
    {children}
  </span>
);
